import { apiGet, apiGetAll, apiPost, apiPut, apiDelete } from '@ibkr/clientportal.common/src/api/default'

const base = '';

const authenticate = (data) => {
    return apiGet(base + '/hmds/auth/init');
}

function getPriceHistory(conid, period, format, source, bar, outsideRth, startTime, direction) {
    const conidObj = { conid, period, format, source, bar, outsideRth, startTime, direction };
    const endPoint = createHistoryEndpoint(conidObj);
    if (endPoint) {
        return apiGet(endPoint);
    }
}

function getPriceHistoryAll(conidObjArr = []) {
    let endPoints = [];
    if (conidObjArr.length > 0) {
        conidObjArr.forEach(conidObj => {
            const endPoint = createHistoryEndpoint(conidObj);
            if (endPoint) {
                endPoints.push(endPoint);
            }
        });
    }
    if (endPoints.length > 0) {
        return apiGetAll(endPoints);
    }
}

function getScannerParams() {
    return apiGet(base + '/hmds/scanner/params');
}

function postScannerQuery(instrument, type, filter, location, delayedLocations, secType, maxItems) {
    return apiPost(base + '/hmds/scanner/run', {
        instrument: instrument,
        scanCode: type,
        locations: location,
        delayedLocations: delayedLocations,
        maxItems: maxItems,
        secType: secType,
        filters: filter
    });
}

function createHistoryEndpoint(conidObj) {
    const { conid, period = '1w', format = '', source = '', bar = '', outsideRth = false, startTime, direction } = conidObj;
    if (isNaN(conid)) {
        return;
    }
    let append = '&period=' + period
    if (format != '') {
        append += '&format=' + format
    }
    if (source != '') {
        append += '&source=' + source
    }
    if (bar != '') {
        append += '&bar=' + bar
    }
    if (startTime) {
        append += '&startTime=' + startTime
    }
    if (direction) {
        append += '&direction=' + direction
    }
    append += '&outsideRth=' + outsideRth;
    return base + '/hmds/history?conid=' + conid + append;
}



export default {
    authenticate,
    getPriceHistory,
    getPriceHistoryAll,
    getScannerParams,
    postScannerQuery
}